import type { UseMutationOptions } from '@tanstack/react-query';
import { mutationOptions } from '@tanstack/react-query';
import { Platform } from 'react-native';

import apiClient from '@/constants/http';

import type {
  AcceptWaitlistSlotPayload,
  AcceptWaitlistSlotResponse,
} from './types';

async function acceptWaitlistSlot(
  payload: AcceptWaitlistSlotPayload,
): Promise<AcceptWaitlistSlotResponse> {
  const { data } = await apiClient.post<AcceptWaitlistSlotResponse>(
    '/v1/book-appointment-time-slot',
    {
      waitingListCustomerId: payload.waitingListCustomerId,
      waitingListSlotId: payload.waitingListSlotId,
      platform: Platform.select({
        ios: 'Flagship iOS',
        android: 'Flagship Android',
        default: 'Web',
      }),
    },
  );

  return data;
}

export const acceptWaitlistSlotMutation = (
  options?: UseMutationOptions<
    AcceptWaitlistSlotResponse,
    Error,
    AcceptWaitlistSlotPayload
  >,
) =>
  mutationOptions({
    ...options,
    retry: false,
    mutationKey: ['acceptWaitlistSlot'],
    mutationFn: acceptWaitlistSlot,
  });
